<template>
  <component
    :is="collectionMeta.link ? 'a' : 'div'"
    class="collection-content-banner"
    :href="collectionMeta.link"
  >
    <div class="collection-content-banner__media">
      <ArtDirection
        v-if="collectionMeta.image && isMobile && collectionMeta.mediaType === 'image' ||
          !isMobile && collectionMeta.mediaTypeDesktop ==='image'"
        :breakpoint-sizes="'640-1152-1536-2048-2460-2880'"
        :block-class="'collection-content-banner'"
        :image-desktop="collectionMeta.imageDesktop"
        :image="collectionMeta.image"
        :padding="true"
      />
      <HeroBannerVideo
        v-if="isMobile && collectionMeta.mediaType === 'video' ||
          !isMobile && collectionMeta.mediaTypeDesktop ==='video'
        "
        :block-class="'collection-content-banner'"
        :video-src="isMobile ? collectionMeta.video : collectionMeta.videoDesktop"
        :padding="true"
      />
    </div>
  </component>
</template>

<script>

/**
 * Vue: Collection content banner (collection-content-banner)
 * -----------------------------------------------------------------------------
 * Promo blocks that can be inserted into collection templates.
 * - Static section.
 *
 * @param {Object} collectionMeta - Meta information from collection object
 */
import { mapState } from 'vuex'

import ArtDirection from '~global/images/art-direction'
import HeroBannerVideo from '~async/hero-banner/hero-banner-video'

export default {
  name: 'CollectionContentBanner',

  components: {
    ArtDirection,
    HeroBannerVideo,
  },

  props: {
    collectionMeta: {
      type: Object,
      default: () => null,
    },
  },

  computed: {

    /**
     * Map Vuex state.
     */
    ...mapState({
      isMobile: (state) => state.index.screen.mobile,
    }),
  },
}
</script>

<style lang="scss">
@import './collection-content-banner';
</style>
